<template>
    <div class="content_box">
        <div class="content">
            <div class="title">
                <span>销售统计明细</span><br><br>
            </div>
            <div class="search_box">
                <el-form :inline="true" class="demo-form-inline search-form form-list" label-width="90px">
                    <el-form-item>
                        <el-select v-model="searchData.platform_list" multiple collapse-tags clearable
                            :popper-append-to-body="false" placeholder="销售渠道" @change="getParamList">
                            <el-option :label="item.dictItemDesc" :value="item.dictItem"
                                v-for="(item,i) in realityData.platform_list" :key="item.dictItemDesc + i"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.seller_list" multiple collapse-tags clearable
                            :popper-append-to-body="false" placeholder="销售店铺" @change="getParamList">
                            <el-option :label="item" :value="item" v-for="(item,i) in realityData.seller_list"
                                :key="item + i"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.product_cate_list" multiple collapse-tags clearable
                            :popper-append-to-body="false" placeholder="产品大类" @change="getParamList">
                            <el-option :label="item.dictItem" :value="item.id"
                                v-for="item in realityData.product_cate_list" :key="item.dictItem + '123'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.product_type_list" collapse-tags placeholder="产品型号"
                            :popper-append-to-body="false" clearable multiple @change="getParamList">
                            <el-option :label="item.dictItem" :value="item.id"
                                v-for="(item, i) in realityData.product_type_list" :key="item.dictItem + i + '321'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.ASIN_list" multiple collapse-tags clearable
                            :popper-append-to-body="false" placeholder="ASIN" @change="getParamList">
                            <el-option :label="item" :value="item" v-for="(item,i) in realityData.ASIN_list"
                                :key="item + i"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.team_list" multiple collapse-tags clearable
                            :popper-append-to-body="false" placeholder="业务团队" @change="getParamList">
                            <el-option :label="item" :value="item" v-for="(item,i) in realityData.team_list"
                                :key="item + i"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.mate_list" multiple collapse-tags clearable
                            :popper-append-to-body="false" placeholder="业务人员" @change="getParamList">
                            <el-option :label="item" :value="item" v-for="(item,i) in realityData.mate_list"
                                :key="item + i"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form_item date_picker noborder">
                        <DatePicker :date="createTime" :clearable="true" @dateSelect="dateSelect"></DatePicker>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button search white" @click="init">
                            <span>重置</span>
                        </div>
                        <div class="button export" @click="exportSalesDetail"
                            v-if="$store.state.type == 'pc'  && roleCheck('102-100-104-102')">
                            <span>导出</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-table :data="salesList" highlight-current-row :fit="true" style="width:120%">
                <el-table-column prop="date" label="日期" width="130" fixed>
                </el-table-column>
                <el-table-column prop="platform" label="销售渠道" width="140" fixed>
                </el-table-column>
                <el-table-column prop="sellerName" label="销售店铺" width="130" fixed>
                </el-table-column>
                <el-table-column prop="SKU" label="平台SKU" width="200" show-overflow-tooltip fixed>
                </el-table-column>
                <el-table-column prop="productCategory" label="产品大类" width="120" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.productCategory || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="productType" label="产品型号" width="130" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.productType || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="ASIN" label="ASIN" width="120">
                </el-table-column>
                <el-table-column prop="teamName" label="业务团队" width="120">
                    <template slot-scope="scope">
                        <span>{{ scope.row.teamName || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mateName" label="业务人员" width="130">
                    <template slot-scope="scope">
                        <span>{{ scope.row.mateName || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="abbr" label="订单国家">
                </el-table-column>
                <el-table-column prop="city" label="订单城市" width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.city || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="saleNum" label="销量" width="130">
                </el-table-column>
                <el-table-column prop="totalSaleAmount" label="总销售额" width="130">
                    <template slot="header" slot-scope="scope">
                        <div class="table_label">
                            <span>总销售额</span>
                            <el-tooltip popper-class="shadow" effect="light" placement="top-start"
                                content="未经扣除折扣/优惠等费用的销售额">
                                <img class="icon-tip tip_padd" src="../../../assets/images/ico/ic_tip.png" alt="">
                            </el-tooltip>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.totalSaleAmount) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="saleAmount" label="实际销售额" width="120">
                    <template slot="header" slot-scope="scope">
                        <div class="table_label">
                            <span>实际销售额</span>
                            <el-tooltip popper-class="shadow" effect="light" placement="top-start"
                                content="经过扣除折扣/优惠等费用的销售额">
                                <img class="icon-tip tip_padd" src="../../../assets/images/ico/ic_tip.png" alt="">
                            </el-tooltip>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.saleAmount) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="gross_profit" label="毛利润" width="120">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.gross_profit) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="total_cost" label="总成本" width="120">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.total_cost) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="refundNum" label="退款量" width="130">
                </el-table-column>
                <el-table-column prop="refundAmount" label="退款额" width="120">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.refundAmount) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="cgPrice" label="采购成本" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.cgPrice) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sellingFee" label="平台费" width="120">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.sellingFee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="promotionFee" label="促销费" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.promotionFee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="adsFee" label="广告费" width="120">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.adsFee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="storageFee" label="仓储费" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.storageFee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="send_fee" label="发货费" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.send_fee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="headFee" label="头程">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.headFee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="fbaFee" label="尾程" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.fbaFee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="operatingFee" label="营销费用" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.operatingFee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="otherFee" label="其他费用" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.otherFee) || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
        </div>
    </div>
</template>
<script>

export default ({
    name: 'sales-detail',
    data() {
        return {
            createTime: [],
            searchData: {
                ASIN_list: [],
                platform_list: [],
                team_list: [],
                mate_list: [],
                seller_list: [],
                product_cate_list: [],
                product_type_list: [],
                start_time: '',
                end_time: '',
                page_size: 10,
                page: 1,
            },
            total: 0,
            salesList: [],
            rootData: {  //原始数据
                product_cate_list: [],
                platform_list: [],
                product_type_list: [],
                product_list: [],
            },
            realityData: {  //真实显示数据
                platform_list: [],
                team_list: [],
                mate_list: [],
                seller_list: [],
                country_list: [],
                product_cate_list: [],
                product_type_list: [],
                ASIN_list: []
            },
            country_list: [],
        }
    },
    watch: {
        createTime: function (nTime) {
            if (nTime && nTime.length > 1) {
                this.searchData.start_time = this.formDate(nTime[0], 'YYYY-MM-DD');
                this.searchData.end_time = this.formDate(nTime[1], 'YYYY-MM-DD');
            } else {
                this.searchData.start_time = '';
                this.searchData.end_time = '';
            }
            this.getParamList();
        },
    },
    created() {
        this.getCountry();
        this.getDictData();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getSalesDetail();
        },
        init() {
            this.searchData.platform_list = [];
			this.searchData.team_list = [];
			this.searchData.seller_list = [];
			this.searchData.ASIN_list = [];
			this.searchData.product_cate_list = [];
			this.searchData.product_type_list = []; 
			this.searchData.mate_list = []; 
			this.searchData.page_size = 10; 
			this.searchData.page = 1; 
            this.createTime = this.setDate(new Date().getDate());
        },
        dateSelect(date) {
            this.createTime = date ? [...date] : '';
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getSalesDetail();
        },
        getSalesDetail() {
            this.api.getSalesDetail(this.searchData).then(data => {
                var list = data.data.result || [];
                this.total = data.data.total;
                var that = this;
                list.forEach(function (item, index, arr) {
                    that.rootData.platform_list.forEach(platform => {
                        if (platform.dictItem == item.platform) {
                            arr[index].platform = platform.dictItemDesc;
                            return;
                        }
                    });
                    that.rootData.product_list.forEach(product => {
                        if (product.id == item.productCategory) {
                            arr[index].productCategory = product.dictItemDesc;
                            return;
                        }
                    });
                    that.rootData.product_list.forEach(product => {
                        if (product.id == item.productType) {
                            arr[index].productType = product.dictItem;
                            return;
                        }
                    });
                    that.countryList.forEach(country => {
                        if (country.abbr == item.abbr || country.code == item.abbr) {
                            arr[index].abbr = country.chinese;
                            return;
                        }
                    });
                });

                this.salesList = list;
                // this.getParamList();
            })
        },
        getDictData() {
            this.api.getDictData().then((data) => {
                this.rootData.platform_list = data.data.result['平台'];
                this.rootData.product_cate_list = data.data.result['产品大类'];
                this.rootData.product_list = data.data.result_list;
                // this.productList = data.data.result_list;
                // this.rootData.product_cate_list.forEach(item => {
                //     product_type_list = [...product_type_list, ...data.data.result[item.dictItem]];
                // })
                this.rootData.product_type_list = data.data.result_list;
                this.createTime = this.setDate(new Date().getDate());
                if (this.createTime.length > 0) {
                    this.searchData.start_time = this.formDate(this.createTime[0], 'YYYY-MM-DD');
                    this.searchData.end_time = this.formDate(this.createTime[1], 'YYYY-MM-DD');
                    this.getSalesDetail();
                }
            })
        },
        getParamList() {
            this.api.getParamList(this.searchData).then(data => {
                const d = data.data.result;
                this.realityData = {  //初始化真实显示数据
                    team_list: d.team_list,
                    seller_list: d.seller_list,
                    mate_list: d.mate_list,
                    ASIN_list: d.ASIN_list,
                    platform_list: [],
                    country_list: [],
                    product_cate_list: [],
                    product_type_list: []
                };
                for (let i = 0; i < this.rootData.platform_list.length; i++) {
                    if (d.platform_list.indexOf(this.rootData.platform_list[i].dictItem) != -1) {
                        this.realityData.platform_list.push(this.rootData.platform_list[i]);
                    }
                }
                for (let i = 0; i < this.rootData.product_cate_list.length; i++) {
                    if (d.product_cate_list.indexOf(this.rootData.product_cate_list[i].id) != -1) {
                        this.realityData.product_cate_list.push(this.rootData.product_cate_list[i]);
                    }
                }
                for (let i = 0; i < this.rootData.product_type_list.length; i++) {
                    if (d.product_type_list.indexOf(this.rootData.product_type_list[i].id) != -1) {
                        this.realityData.product_type_list.push(this.rootData.product_type_list[i]);
                    }
                }
            })
        },
        getCountry() {
            this.api.getCountry({}).then(data => {
                this.countryList = data.data.country;
            })
        },
        exportSalesDetail() {
            this.api.exportSalesDetail(this.searchData).then(data => {
                // this.countryList = data.data.country;
            })
        }
    }
})
</script>
<style lang="less" scoped>
.content {
    background-color: @colorWhite;

    /deep/ .el-select__tags {
        flex-wrap: nowrap;
        overflow: hidden;
    }

    .export {
        width: 72px;
    }

    .table_label{
        .flexLayout();
        flex-wrap: nowrap;
        .tip_padd{
            padding-top: 5px;
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/view/statistics/sales/sales-detail.vue